module.exports = __webpack_public_path__ + "img/indexm.dffca4f4.png";